import { AnnouncementFormData } from '../types';

/**
 * Convert form state (PascalCase) to API payload (camelCase).
 * The backend destructures: { title, description, expireDate, moreLink }
 */
const makeAnnouncementObj = (formState: AnnouncementFormData, createdByUser?: string): Record<string, unknown> => {
  const obj: Record<string, unknown> = {
    title: formState.Title,
    description: formState.Description,
    moreLink: formState.MoreLink || '',
    expireDate: formState.ExpireDate || '',
  };
  if (createdByUser) {
    obj.createdByUser = createdByUser;
  }
  return obj;
};

export default makeAnnouncementObj;
